export default __webpack_public_path__ + "static/media/KOD0067-min.0dbf90ce.webp";